import { default as DeleteModal } from "./DeleteModal";
import { default as EditModal } from "./EditModal";
const Modals = {
  EditModal,
  DeleteModal,
};

export default Modals;
